const Credentials = () => {
  return {
    ClientId: "92bbc2cb295d4ae09e01cd1696d1af65",
    ClientSecret: "336ba3d267244d59bce1035caa6af7df",
  };
};

export { Credentials };
